// Shared display formatters (currency + dates) so amounts and dates read
// identically across the fee UI — the student "My Fees" timeline and the admin
// Fees tabs. Previously the student components concatenated a bare "₹" with an
// unformatted number ("₹18000") while the admin tabs used Intl grouping
// ("₹18,000"); this is the single source for both.

// ₹18,000 — Indian grouping, whole rupees (no paise).
const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/**
 * Format a rupee amount as "₹18,000". Null/undefined/NaN render as "₹0".
 * @param {number} amount
 * @returns {string}
 */
export const formatINR = (amount) => inr.format(Number(amount) || 0);

/**
 * Format a date as "23 Jul 2026". Falsy/invalid dates render as "N/A".
 * @param {string|number|Date} date
 * @returns {string}
 */
export const formatDate = (date) => {
  if (!date) return "N/A";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "N/A";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
